import { render, staticRenderFns } from "./pricemanagement.vue?vue&type=template&id=0d9fbaec&scoped=true&"
import script from "./pricemanagement.vue?vue&type=script&lang=js&"
export * from "./pricemanagement.vue?vue&type=script&lang=js&"
import style0 from "./pricemanagement.vue?vue&type=style&index=0&id=0d9fbaec&lang=scss&scoped=true&"
import style1 from "./pricemanagement.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./pricemanagement.vue?vue&type=style&index=2&id=0d9fbaec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fbaec",
  null
  
)

export default component.exports